const images = {
    ic_logout: require('../../assets/img/icons/images/ic_logout.png'),
    ic_default_avatar: require('../../assets/img/icons/images/ic_default_avatar.png'),
    ic_input_file: require('../../assets/img/icons/images/ic_input_file.png'),
    ic_photo: require('../../assets/img/icons/images/ic_photo.png'),
    ic_sticker: require('../../assets/img/icons/images/ic_sticker.png'),
    ic_send: require('../../assets/img/icons/images/ic_send.png'),
    ic_wave_hand: require('../../assets/img/icons/images/ic_wave_hand.png'),

    mimi1: require('../../assets/img/icons/images/mimi1.gif'),
    mimi2: require('../../assets/img/icons/images/mimi2.gif'),
    mimi3: require('../../assets/img/icons/images/mimi3.gif'),
    mimi4: require('../../assets/img/icons/images/mimi4.gif'),
    mimi5: require('../../assets/img/icons/images/mimi5.gif'),
    mimi6: require('../../assets/img/icons/images/mimi6.gif'),
    mimi7: require('../../assets/img/icons/images/mimi7.gif'),
    mimi8: require('../../assets/img/icons/images/mimi8.gif'),
    mimi9: require('../../assets/img/icons/images/mimi9.gif'),
    play1: require('../../assets/img/icons/images/play.png'),
    play2: require('../../assets/img/icons/images/play-button.png'),
    errorCircle: require('../../assets/img/icons/images/error-circle.png'),
    errorX: require('../../assets/img/icons/images/error-x.jpg'),
}

export default images;